import { ItemsTable } from '../job/ItemsTable';

export const ItemsResults = ({ job, ...props }) => {
  if (!job?.results?.items) {
    return null;
  }

  return (
    <div>
      <ItemsTable job={job} jobId={job.id} items={job.results.items} {...props} />
    </div>
  );
};
